import { Divider, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import { useWizardStepContext } from 'v2/components/WizardModal';
import useTenantName from 'v2/hooks/onboarding/useTenantName/useTenantName';

const STEP_INDEX = 1;

const WaitingForPermissionsStep: React.FC<React.PropsWithChildren> = () => {
  const [searchParams] = useSearchParams();
  const azureTenantId = searchParams.get('tenant');
  const { setFooterContent, steps, goToNext } = useWizardStepContext();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });
  const { tenantName, loading } = useTenantName({
    azureTenantId,
    handleFetchError
  });

  React.useLayoutEffect(() => {
    setFooterContent(STEP_INDEX, <></>);
  }, [setFooterContent, steps]);

  useEffect(() => {
    if (!loading && tenantName) goToNext();
  }, [loading, tenantName, goToNext]);

  return (
    <Stack flexDirection="column" gap={1}>
      <Typography variant="h5" color="textPrimary">
        Waiting for permissions
      </Typography>
      <Divider />
      <Typography variant="body2" color="textPrimary">
        Please hold on while ATLAS completes the setup process. Once the necessary permissions are configured,
        you&apos;ll be automatically redirected to the next page.
      </Typography>
      <Divider />
    </Stack>
  );
};
export default WaitingForPermissionsStep;
